riot.tag2('bbc-notifications-onboarding-u13', '<div class="notifications-full notifications-u13--onboarding-image"> <div class="notifications__container"> <div class="notifications-u13--close-drawer" onclick="{close}"></div> <div class="notifications-u13--content"> <div class="notifications-layout"> <div class="notifications-layout__item gel-bp-s-8/12 gel-bp-m-6/12"> <div if="{opts.state.policyIssue === \'parentId\' || opts.state.policyIssue === \'guardianEmail\'}" id="bbc-notifications-onboarding-u13-parentID"> <p class="notifications-trafalgar-bold"><i1-8n>copy.under13.parentId.title</i1-8n></p> <p class="notifications-pica bbc-notifications-onboarding-u13-permission-msg" id="u13-msg"> <i1-8n> {u13BodyMsg} </i1-8n> </p> </div> <div if="{opts.state.policyIssue === \'linkPending\'}" id="bbc-notifications-onboarding-u13-linkPending"> <p class="notifications-trafalgar-bold"><i1-8n>copy.under13.linkPending.title</i1-8n></p> <p class="notifications-pica"><i1-8n>copy.under13.linkPending.body</i1-8n></p> </div> <div if="{opts.state.policyIssue === \'permissionNotifications\'}" id="bbc-notifications-onboarding-u13-permissionNotifications"> <p class="notifications-trafalgar-bold"><i1-8n>copy.under13.permissionNotifications.title</i1-8n></p> <p class="notifications-pica"><i1-8n>copy.under13.permissionNotifications.body</i1-8n></p> </div> </div> </div> <div class="notifications-layout"> <div class="notifications-20/24 notifications-layout__item notifications-u13--options"> <div id="u13-ok-btn" if="{opts.state.policyIssue === \'parentId\' || opts.state.policyIssue === \'guardianEmail\'}"> <a href="{buttonLink}" class="notifications-u13--ok-button notifications-pica-bold"><span><i1-8n>{u13BtnMsg}</i1-8n></span></a> </div> <div class="notifications-u13--more"> <a href="{this.moreInfoLink}" class="notifications-pica-bold"><span class="notifications-u13--info-icon"></span><i1-8n>copy.under13.moreInfo</i1-8n></a> </div> </div> </div> </div> <div class="notifications-u13--overlay"></div> </div> </div>', '', '', function(opts) {
'use strict';

var _this = this;

var config = require('../config');
var i18n = require('riot-i18n');
var UserState = require('../models/UserState');
var UserPreference = require('../models/UserPreferences');

this.moreInfoLink = config.env.under13s.moreInfo;

this.close = function () {
    opts.mainApp.navNotificationElement.click();
};

this.on('mount', function () {
    // Extracts the upsell button link from IDCTA html
    // To be ripped out if/when ID updates their responses
    if (opts.state.idctaResponse && opts.state.idctaResponse.html && opts.state.policyIssue && (opts.state.policyIssue === 'parentId' || opts.state.policyIssue === 'guardianEmail')) {
        var link = opts.state.idctaResponse.html.match(/<a\s+(?:[^>]*?\s+)?href="([^"]*)"/);
        if (link[1]) {
            _this.update({ buttonLink: link[1] });
        }

        var lang = i18n.getLanguage();
        var endpoint = UserPreference.fetchCorrectDomainEndpoint(config.env.preferencesUrls.translationsUK, config.env.preferencesUrls.translations);

        var idctaTranslateUrl = endpoint + '?locale=' + lang;
        var hostname = location.protocol + '//' + window.location.hostname;
        fetch(idctaTranslateUrl, { Origin: hostname }).catch(function () {
            // fallback to the hard-coded translations
            _this.update({ u13BodyMsg: 'copy.under13.parentId.body' });
            _this.update({ u13BtnMsg: 'copy.under13.parentId.button' });
        }).then(function (res) {
            return res.json();
        }).then(function (data) {
            var translationData = data.translation_guardianconsentrequired;

            if (translationData.endsWith('.')) {
                translationData = translationData.substring(0, translationData.length - 1);
            }

            translationData = translationData.replace('{additionalDetailsHref}', 'id="u13-permission-btn"');

            document.getElementById('u13-ok-btn').innerHTML = '';

            document.getElementById('u13-msg').innerHTML = UserState.convertHtml(translationData).html;
            document.getElementById('u13-permission-btn').setAttribute('class', 'notifications-u13--ok-button notifications-pica-bold bbc-notifications-onboarding-u13-BTN');
            document.getElementById('u13-permission-btn').setAttribute('href', link[1]);
        });
    }

    if (typeof localStorage !== 'undefined') {
        localStorage.setItem('bbc-notifications-u13-pending-policy', true);
    }
});
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-onboarding-u13.tag
 ** module id = 28
 ** module chunks = 0
 **/